module.exports = __webpack_public_path__ + "img/loader.f438621b.svg";